module.exports = __webpack_public_path__ + "img/user-ico.cd45b846.svg";